import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { trackEvent, trackEcommerce } from 'dibs-tracking';
import { FullWidthDropdown } from '../Dropdown/FullWidthDropdown';
import { SiteNavDropdownContent } from './SiteNavDropdownContent';
import { slugify } from '../../utils/slugify';
import classnames from 'classnames';
import styles from './SiteNav-style.scss';

const getTradePromoTrackingObj = ({ name, imageLink }) => {
    return {
        id: `trade-trending-tile-${name.toLowerCase()}`,
        name: 'trade-trending-tile',
        creative: imageLink,
    };
};

export class SiteNavItemComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = { isVisible: false };
        this.onHide = this.onHide.bind(this);
        this.onShow = this.onShow.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleImageModuleClick = this.handleImageModuleClick.bind(this);
        this.handleImageModuleFirstImpression = this.handleImageModuleFirstImpression.bind(this);
    }
    handleClick() {
        const { name } = this.props.navigationModule;

        trackEvent({
            action: 'header navigation click',
            category: 'navigation',
            label: `${name.toLowerCase()} header link|${name.toLowerCase()}`,
        });
    }
    onHide() {
        this.setState({ isVisible: false });
    }
    onShow() {
        this.setState({ isVisible: true });
    }
    handleImageModuleClick() {
        if (this.props.isUserTypeTrade) {
            const tradePromoObj = getTradePromoTrackingObj(this.props.navigationModule);
            trackEcommerce({
                type: 'promoClick',
                promotions: [tradePromoObj],
            });
        }
        trackEvent({
            category: 'navigation',
            action: 'header navigation clicked',
            label: 'trending now',
        });
    }
    handleImageModuleFirstImpression() {
        if (this.props.isUserTypeTrade) {
            const tradePromoObj = getTradePromoTrackingObj(this.props.navigationModule);
            trackEcommerce({
                type: 'promotionImpression',
                promotions: [tradePromoObj],
            });
        }
    }
    render() {
        const { isUserTypeTrade, navigationModule } = this.props;
        const { name, url, isHighlighted, items, isLinkable } = navigationModule;
        const { isVisible } = this.state;
        const itemLinkClasses = classnames(styles.itemLink, { [styles.highlight]: isHighlighted });
        const dropdownProps = {
            onShow: this.onShow,
            onHide: this.onHide,
            wrapperClass: styles.fullWrapper,
        };

        return (
            <div className={styles.item}>
                <FullWidthDropdown {...dropdownProps}>
                    <a
                        className={itemLinkClasses}
                        href={url}
                        data-tn={`global-nav-item-link-${slugify(name).toLowerCase()}`}
                        onClick={this.handleClick}
                        rel={!isLinkable ? 'nofollow' : undefined}
                    >
                        {name}
                        {isVisible && (
                            <div
                                className={
                                    isUserTypeTrade
                                        ? styles.linkUnderlineTrade
                                        : styles.linkUnderline
                                }
                            />
                        )}
                    </a>
                    {items && items.length ? (
                        <SiteNavDropdownContent
                            moduleItems={items}
                            trackingLabelPrefix={name}
                            navigationModule={navigationModule}
                            onImageModuleFirstImpression={this.handleImageModuleFirstImpression}
                            onImageModuleClick={this.handleImageModuleClick}
                            isVisible={isVisible}
                        />
                    ) : null}
                </FullWidthDropdown>
            </div>
        );
    }
}

SiteNavItemComponent.propTypes = {
    isUserTypeTrade: PropTypes.bool,
    isHighlighted: PropTypes.bool,
    navigationModule: PropTypes.object,
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade } = header;
    return {
        isUserTypeTrade,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(SiteNavItemComponent), {
    navigationModule: graphql`
        fragment SiteNavItem_navigationModule on NavigationModule {
            ...SiteNavDropdownContent_navigationModule
            imageLink
            name
            isLinkable
            url
            isHighlighted
            items @include(if: $fetchSubNav) {
                serviceId
                name
                column
                items {
                    serviceId
                    name
                    isLinkable
                    url
                }
            }
        }
    `,
});
